import { render } from "./Footer.vue?vue&type=template&id=b6bcad30&scoped=true"
import script from "./Footer.vue?vue&type=script&lang=js"
export * from "./Footer.vue?vue&type=script&lang=js"

import "./Footer.vue?vue&type=style&index=0&id=b6bcad30&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-b6bcad30"

export default script